module.exports = __webpack_public_path__ + "img/icon-recommend.3edc4f3.webp";